import React, { PureComponent } from 'react'
import { Menu, Grid, Form, Header, Input, Button, Label, Icon, Popup } from 'semantic-ui-react'

import size from 'lodash/size'
import find from 'lodash/find'
import reduce from 'lodash/reduce'
import orderBy from 'lodash/orderBy'

import firebase from '../../../config/firebase'

const styles = {
  menu: {
    width: '100%',
    overflow: 'auto',
    maxHeight: 'calc(100vh - 350px)',
  },
  driver: {
    borderRadius: 0,
    padding: '13px 10px',
  },
  driverRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  driverName: {
    flex: 1,
    fontSize: 15,
    display: 'flex',
    lineHeight: '1.3',
  },
  selectedDriversContainer: {
    display: 'flex',
    userSelect: 'none',
    alignItems: 'center',
    flexDirection: 'row',
  },
  driverItem: {
    padding: 10,
    width: '90%',
    display: 'flex',
    borderRadius: 5,
    margin: '4px 0px',
    flexDirection: 'row',
    background: 'rgb(224, 225, 226)',
  },
}

export default class DriversBlock extends PureComponent {
  state = {
    search: '',
    selectedDriverKeys: [],
  }

  componentDidMount() {
    this.getBlockedDrivers()
  }

  getBlockedDrivers = () => {
    const { drivers } = this.props

    const blockedDrivers = reduce(drivers, (result, driver) => {

      if (driver.has_blocked) result.push(driver.driverUID)

      return result
    }, [])

    this.setState({ selectedDriverKeys: blockedDrivers })
  }

  getBlockReason = () => {
    return new Promise((resolve) => {
      const promptReason = window.prompt('Block Reason', '')

      if (promptReason) resolve(promptReason)

      resolve(false)
    })
  }

  onDriverClick = async driverUID => {
    const { user } = this.props
    const { selectedDriverKeys } = this.state

    try {
      if (selectedDriverKeys.includes(driverUID)) {
        this.onUnblock(driverUID)
      } else {
        const updates = {}
        const blockReason = await this.getBlockReason()

        if (blockReason) {
          updates[`deliverers/${driverUID}/has_blocked`] = true
          updates[`deliverers/${driverUID}/blocked_by`] = user.username
          updates[`deliverers/${driverUID}/blocked_reason`] = blockReason

          await firebase
            .database()
            .ref()
            .update(updates)

          return this.setState({ selectedDriverKeys: selectedDriverKeys.concat(driverUID) })
        }

        return null
      }

      return null
    } catch (err) {
      throw ('Block Function', err)
    }
  }

  onUnblock = async driverUID => {
    const { selectedDriverKeys } = this.state

    try {
      const updates = {}

      updates[`deliverers/${driverUID}/has_blocked`] = null
      updates[`deliverers/${driverUID}/blocked_reason`] = null
      updates[`deliverers/${driverUID}/blocked_by`] = null

      await firebase
        .database()
        .ref()
        .update(updates)

      return this.setState({ selectedDriverKeys: selectedDriverKeys.filter(key => key !== driverUID) })
    } catch (err) {
      throw ('Unblock Function', err)
    }
  }

  renderDriver = driver => {
    const { driverSegments } = this.props
    const { selectedDriverKeys } = this.state

    return (
      <Menu.Item
        style={styles.driver}
        key={driver.driverUID}
        onClick={() => this.onDriverClick(driver.driverUID)}
        active={selectedDriverKeys && selectedDriverKeys.includes(driver.driverUID)}
      >
        <div style={styles.driverRow}>
          <div style={styles.driverName}>
            <Label size="tiny" style={{ marginRight: 10 }}>
              {driver.driverUID}
            </Label>

            {`${driver.family_name} ${driver.first_name}`}

            {driverSegments[driver.driver_segment] ? (
              <Label size="tiny" style={{ marginLeft: 10 }}>
                {driverSegments[driver.driver_segment].name}
              </Label>
            ) : null}
          </div>

          {selectedDriverKeys.includes(driver.driverUID) && <Icon name="check" color="green" style={{ marginRight: 10 }} />}
        </div>
      </Menu.Item>
    )
  }

  renderDrivers = () => {
    const { drivers } = this.props
    const { search } = this.state

    let displayDrivers = Object.values(drivers).filter(driver => {
      const driverName = `${driver.family_name} ${driver.first_name}`.toLowerCase()
      const searchText = search.toLowerCase().trim()

      return driverName.includes(searchText) || driver.driverUID.includes(searchText)
    })

    displayDrivers = orderBy(displayDrivers, ['family_name', 'driver_segment'], ['asc', 'asc'])

    return (
      <div>
        <Input
          type="text"
          icon="search"
          placeholder="Search"
          name="search-driver"
          style={{ width: '100%', marginTop: 10 }}
          onChange={e => this.setState({ search: e.target.value })}
        />
        <Menu vertical style={styles.menu}>
          {displayDrivers.map(driver => this.renderDriver(driver))}
        </Menu>
      </div>
    )
  }

  renderSelectedDrivers = () => {
    const { selectedDriverKeys } = this.state
    const { drivers, driverSegments } = this.props

    return (
      <div style={{ marginTop: 20 }}>
        <Header as="h3" style={{ marginBottom: 22 }}>
          List of Selected Driver ({size(selectedDriverKeys)})
        </Header>

        <div style={styles.menu}>
          {selectedDriverKeys.map(driverKey => {
            const driver = find(drivers, ['driverUID', driverKey])

            if (!driver) return null

            return (
              <div style={styles.selectedDriversContainer} key={driverKey}>
                <Popup
                  position="top right"
                  trigger={
                    <div style={styles.driverItem}>
                      <Label size="tiny" style={{ marginRight: 10 }}>
                        {driver.driverUID}
                      </Label>

                      {`${driver.family_name} ${driver.first_name}`}

                      {driverSegments[driver.driver_segment] ? (
                        <Label size="tiny" style={{ marginLeft: 10 }}>
                          {driverSegments[driver.driver_segment].name}
                        </Label>
                      ) : null}
                    </div>
                  }
                >
                  {`Blocked by : ${driver.blocked_by}`}
                </Popup>

                <div style={{ marginLeft: 8 }}>
                  <Button icon="remove" color="red" onClick={() => this.onUnblock(driverKey)} />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        <div style={{ padding: '7px 14px' }}>
          <Header>Drivers Block</Header>
        </div>

        <Form>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>{this.renderDrivers()}</Grid.Column>
              <Grid.Column>{this.renderSelectedDrivers()}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/views/driversBlock.js